import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PassCompleteReceiverStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PassComplete &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const yardsGained =
            (fragment.receivedAt - play.getContextSnapshot().fieldPosition) *
            gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.receivedBy.teamId,
            playerId: fragment.receivedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.PASS_TARGET,
            values: {
                yards: yardsGained,
                completed: 1,
                attempted: 1
            }
        });
    }
}
